//import Category from './Category/Category.store';
//import Good from './Good/Good.store';
import Order from './Order/Order.store';
import Paypal from './Paypal/Paypal.store';
import MyOrder from './MyOrder/MyOrder.store';
import OrderDetail from './OrderDetail/OrderDetail.store';

export default {
  namespaced: true,
  modules: {
    //Category,
    //Good,
    Order,
    Paypal,
    MyOrder,
    OrderDetail,
  },
};
